import { Chip, ChipProps } from '@mui/material';
import { UiBeneficiary } from '../../types';
import { BankIcon, CoinIcon, ProfileIcon } from '../../icons';
import { AvatarIcon } from '../Avatar/AvatarIcon';

export type BeneficiaryChipProps = ChipProps<'div', { beneficiary: UiBeneficiary }>;

function getBeneficiaryIcon(beneficiary: UiBeneficiary) {
  switch (beneficiary.type) {
    case 'BUSINESS':
      return <BankIcon />;
    case 'INDIVIDUAL':
      return <ProfileIcon />;
    case 'CRYPTO':
      return <CoinIcon />;
  }
}

function getBeneficiaryLabel(beneficiary: UiBeneficiary) {
  switch (beneficiary.type) {
    case 'CRYPTO':
      return beneficiary.beneficiaryName ?? beneficiary.accountNumber.value;
    case 'BUSINESS':
      return beneficiary.businessName;
    case 'INDIVIDUAL':
      return beneficiary.individualName;
  }
}

export function BeneficiaryChip({ beneficiary, ...props }: BeneficiaryChipProps) {
  return (
    <Chip
      {...props}
      avatar={<AvatarIcon icon={getBeneficiaryIcon(beneficiary)} />}
      label={getBeneficiaryLabel(beneficiary)}
    />
  );
}
